import { mount } from "svelte";
import Uploads from "../../../../svelte/src/elements/CornerButtons/Uploads/Uploads.svelte";

export const initializeUploads = (init = true) => {
  if (init) {
    const $wrapper = $("#wrapper");

    const uploadsContainer = document.createElement("div");
    uploadsContainer.id = "uploads-component";
    $wrapper.append(uploadsContainer);

    mount(Uploads, {
      target: uploadsContainer,
    });
  }
};
